import { Quill } from "react-quill-new"

export const CustomUndo = () => {
  const editor = document.querySelector(".ql-editor")
  if (editor) {
    const quill = Quill.find(editor) as any
    quill?.history?.undo()
  }
}

export const CustomRedo = () => {
  const editor = document.querySelector(".ql-editor")
  if (editor) {
    const quill = Quill.find(editor) as any
    quill?.history?.redo()
  }
}
